<sc-flex vertical fitHeight stretchContent *ngIf="movementOrderDetails">
  <sc-dialog-title>
    <sc-dictionary-label dictionaryKey="tmc-yard.ui.movement-orders.moving-order-strategy-dialog.title"></sc-dictionary-label>
  </sc-dialog-title>


  <div class="hint" *ngIf="vehicleSelectionRequired">
    <sc-dictionary-label dictionaryKey="tmc-yard.movement-order-strategy-dialog.ui.select-vehicle"></sc-dictionary-label>
  </div>

  <div class="hint" *ngIf="stationSelectionRequired">
    <sc-dictionary-label dictionaryKey="tmc-yard.ui.movement-orders.moving-order-strategy-dialog.select-target-station"></sc-dictionary-label>
  </div>

  <sc-content-spacer vertical />
  <sc-flex-fitting-content vertical>
    <ng-container *ngIf="vehicleSelectionRequired">
      <sc-padding>
        <form [formGroup]="vehicleOptionsFormGroup">
          <mat-radio-group formControlName="vehicleSelectionMode">
            <mat-radio-button value="automatically">
              <sc-dictionary-label dictionaryKey="tmc-yard.movement-order-strategy-dialog.ui.vehicle-selection-mode.automatically"></sc-dictionary-label>
            </mat-radio-button>
            <mat-radio-button value="manually">
              <sc-dictionary-label dictionaryKey="tmc-yard.movement-order-strategy-dialog.ui.vehicle-selection-mode.manually"></sc-dictionary-label>
            </mat-radio-button>
          </mat-radio-group>
        </form>
        <app-moving-order-vehicle-selection *ngIf="vehicleSelectionMode === 'manually'"
          [vehicleStrategy]="movementOrderDetails.vehicleStrategy"
          (selectedVehicle)="selectedVehicleChanged($event)"></app-moving-order-vehicle-selection>
        <sc-content-spacer grow></sc-content-spacer>
      </sc-padding>
    </ng-container>

    <ng-container *ngIf="stationSelectionRequired">
      <app-structure-selection [request]="structureSelectionRequest" (selectionChanged)="handleSelectionChanged($event)"></app-structure-selection>
    </ng-container>
  </sc-flex-fitting-content>



  <sc-padding>
    <sc-flex>
      <sc-content-spacer grow></sc-content-spacer>
      <sc-cancel-button (click)="cancelDialog()" dictionaryKey="tmc-yard.common.action.cancel"></sc-cancel-button>
      <sc-content-spacer></sc-content-spacer>
      <sc-confirm-button primary [disabled]="!confirmDialogEnabled" (click)="confirmDialog()" dictionaryKey="tmc-yard.ui.movement-orders.moving-order-strategy-dialog.action.create-movement-order"></sc-confirm-button>
    </sc-flex>
  </sc-padding>
</sc-flex>
